import {
  LOCALE_ID,
  ApplicationConfig,
  provideZonelessChangeDetection,
} from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {
  provideRouter,
  withInMemoryScrolling,
  withDisabledInitialNavigation,
} from '@angular/router';

registerLocaleData(localeEs, 'es');
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { definePreset } from '@primeuix/themes';
import { providePrimeNG } from 'primeng/config';

import { routes } from './app.routes';
import {
  csrfInterceptor,
  authRefreshInterceptor,
  subscriptionInterceptor,
  concurrencyConflictInterceptor,
} from './core/interceptors';

const PlanTrackPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      dark: {
        surface: {
          0: '#ffffff',
          50: '#c8cdd6',
          100: '#8b95a8',
          200: '#8b95a8',
          300: '#c8cdd6',
          400: '#8b95a8',
          500: '#6b7585',
          600: '#555d72',
          700: '#4b5263',
          800: '#424858',
          900: '#3e4452',
          950: '#383c4a',
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withDisabledInitialNavigation(),
    ),
    provideHttpClient(
      withInterceptors([
        authRefreshInterceptor,
        csrfInterceptor,
        subscriptionInterceptor,
        concurrencyConflictInterceptor,
      ]),
    ),
    providePrimeNG({
      theme: {
        preset: PlanTrackPreset,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
    MessageService,
    { provide: LOCALE_ID, useValue: 'es' },
  ],
};
